import { TabbedBlockChildListType } from "../templates/docs.utils";
import React, { useState } from "react";

export type Props = {
  tabs: TabbedBlockChildListType[];
};

const TabbedBlocks = ({ tabs }: Props) => {
  const [active, setActive] = useState(0);

  return (
    <div className="border border-white-grey dark:border-light-grey rounded p-2 my-4 flex flex-col">
      <div className="flex flex-row justify-between h-8 md:h-12 border-b border-white-grey dark:border-light-grey pb-2">
        <div className="flex flex-row justify-start">
          {tabs.map((tab, index) => {
            return (
              <button
                key={index}
                onClick={() => setActive(index)}
                className={`px-2 text-white text-xs md:text-md mx-1 rounded rounded-l shadow-md ${
                  active === index
                    ? "bg-vivid-orange text-white font-bold"
                    : "bg-medium-dark-grey text-black font-bold"
                }`}
              >
                {tab.title ? tab.title : tab.id}
              </button>
            );
          })}
        </div>
      </div>
      {tabs[active].renderedContent}
    </div>
  );
};
export default TabbedBlocks;
